/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ChevronRightLg: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="chevron-right-lg" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1043.46 680L493.3966666666667 129.9366666666667L413.2700000000001 210.0633333333335L883.2066666666666 680L413.27 1149.9366666666667L493.3966666666667 1230.0633333333333L1043.46 680z" : "M834.7680000000001 544L394.7173333333334 103.9493333333332L330.6160000000001 168.0506666666667L706.5653333333333 544L330.6160000000001 919.9493333333334L394.7173333333334 984.0506666666666L834.7680000000001 544z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ChevronRightLg.displayName = `Blueprint5.Icon.ChevronRightLg`;
export default ChevronRightLg;
